export type FeatureTogglesType = string[];

export enum FEATURE_TOGGLE_LIST {
  COOKIEDISABLED = 'COOKIEDISABLED',
  PERSONALISED_SECTION = 'PERSONALISED_SECTION',
  NO_FAVS = 'noFaves',
  CLO = 'CLO',
  AMEX_MGM = 'AMEX_MGM',
  TOP_PICKS = 'TOP_PICKS',
  DOWNLOAD_APP_PROMPT = 'DOWNLOAD_APP_PROMPT',
  PDP_BREADCRUMBS = 'PDP_BREADCRUMBS',
  ONETRUST_COOKIES = 'ONETRUST_COOKIES',
  TEMP_GPT_IN_SEARCH_RESULTS = 'TEMP_GPT_IN_SEARCH_RESULTS',
  TEMP_PARENT_DOMAIN_COOKIE = 'TEMP_PARENT_DOMAIN_COOKIE',
  TEMP_USE_SSO_ON_PAGE_LOAD = 'TEMP_USE_SSO_ON_PAGE_LOAD',
  TEMP_AVIOS_TIMELINE = 'TEMP_AVIOS_TIMELINE',
  TEMP_AVIOS_ALTO_COMPONENTS = 'TEMP_AVIOS_ALTO_COMPONENTS',
  TEMP_CONSOLIDATED_HOUSEHOLD_AVIOS = 'TEMP_CONSOLIDATED_HOUSEHOLD_AVIOS', // This one will be removed from Contentful, as it is not being used, and there will be a ticket to fix this accordingly
  TEMP_ALTO_ACCORDION = 'TEMP_ALTO_ACCORDION',
}
